<template>
  <v-container fluid>
    <v-app-bar dark app color="primary">
      <v-app-bar-nav-icon>
        <v-icon>mdi-bank</v-icon>
      </v-app-bar-nav-icon>
      <v-toolbar-title>Übersicht Finanzen</v-toolbar-title>
    </v-app-bar>
    <v-card :loading="loading" max-width="400" class="mx-auto mt-4">
      <v-system-bar>Beitrag Kanton</v-system-bar>
      <v-toolbar flat>
        <DateInput
          label="von"
          v-model="startDate"
          hideDetails
          class="mr-2"
          clearable
        ></DateInput>
        <DateInput
          label="bis"
          v-model="endDate"
          hideDetails
          class="mx-2"
          clearable
        ></DateInput>

        <v-spacer></v-spacer>
      </v-toolbar>
      <v-divider></v-divider>
      <v-list>
        <v-list-item>
          <v-list-item-content>
            <v-list-item-subtitle>Anzahl Transaktionen</v-list-item-subtitle>
          </v-list-item-content>
          <v-list-item-action>{{ transactions.length }}</v-list-item-action>
        </v-list-item>
        <v-list-item>
          <v-list-item-content>
            <v-list-item-subtitle>Anzahl Ersteller</v-list-item-subtitle>
          </v-list-item-content>
          <v-list-item-action>{{ creatorCount }}</v-list-item-action>
        </v-list-item>
        <v-list-item>
          <v-list-item-content>
            <v-list-item-subtitle>Anzahl Personen</v-list-item-subtitle>
          </v-list-item-content>
          <v-list-item-action>{{ personCount }}</v-list-item-action>
        </v-list-item>
        <v-list-item>
          <v-list-item-content>
            <v-list-item-subtitle>Anzahl Klassen</v-list-item-subtitle>
          </v-list-item-content>
          <v-list-item-action>{{ schoolClassCount }}</v-list-item-action>
        </v-list-item>
        <v-list-item>
          <v-list-item-content>
            <v-list-item-subtitle>Anzahl Anlässe</v-list-item-subtitle>
          </v-list-item-content>
          <v-list-item-action>{{ eventCount }}</v-list-item-action>
        </v-list-item>
      </v-list>
      <v-divider></v-divider>
      <SparkLine
        class="mt-2"
        width="400"
        height="160"
        :data="transactionSparkline"
      ></SparkLine>
      <v-card-text class="text-h5 text-center">
        <CurrencyValue :value="transactionSum" class="pa-4" />
      </v-card-text>
    </v-card>
  </v-container>
</template>
<script>
import { defineComponent } from "vue";
import { addDays, today } from "common/utils/date.js";
import DateInput from "common/components/DateInput.vue";
import { sum } from "lodash";
import CurrencyValue from "common/components/CurrencyValue.vue";
import SparkLine from "common/components/SparkLine.vue";

export default defineComponent({
  name: "FinanceOverview",
  components: {
    CurrencyValue,
    DateInput,
    SparkLine,
  },
  data() {
    return {
      transactions: [],
      loading: false,
      startDate: null,
      endDate: null,
    };
  },
  watch: {
    startDate() {
      this.fetchData();
    },
    endDate() {
      this.fetchData();
    },
  },
  computed: {
    transactionSum() {
      return sum(
        this.transactions.map((transaction) =>
          Number.parseFloat(transaction.amount)
        )
      );
    },
    creatorCount() {
      return this.transactions.reduce((acc, transaction) => {
        if (!acc.includes(transaction.creator.id)) {
          acc.push(transaction.creator.id);
        }
        return acc;
      }, []).length;
    },
    eventCount() {
      return this.transactions.reduce((acc, transaction) => {
        if (transaction.event && !acc.includes(transaction.event)) {
          acc.push(transaction.event);
        }
        return acc;
      }, []).length;
    },
    personCount() {
      return this.transactions.reduce((acc, transaction) => {
        if (!acc.includes(transaction.person.id)) {
          acc.push(transaction.person.id);
        }
        return acc;
      }, []).length;
    },
    schoolClassCount() {
      return this.transactions.reduce((acc, transaction) => {
        if (
          transaction.person.schoolClass &&
          !acc.includes(transaction.person.schoolClass.id)
        ) {
          acc.push(transaction.person.schoolClass.id);
        }
        return acc;
      }, []).length;
    },
    transactionCount() {
      return this.transactions.length;
    },
    transactionSparkline() {
      if (!this.startDate || !this.endDate) {
        return [];
      }
      let day = this.startDate;
      let result = [0];
      while (day <= this.endDate) {
        const total = sum(
          this.transactions
            .filter((transaction) => transaction.date <= day)
            .map((transaction) => Number.parseFloat(transaction.amount))
        );
        result.push(total);
        day = addDays(day, 1);
      }
      return result;
    },
  },
  methods: {
    async fetchData() {
      if (!this.startDate || !this.endDate) {
        return;
      }
      this.loading = true;
      this.transactions = await this.apiList({
        resource: "finance/persontransaction",
        query: `type=cantonal&startDate=${this.startDate}&endDate=${this.endDate}`,
      });
      this.loading = false;
    },
  },
  created() {
    this.startDate = today();
    this.endDate = today();
    this.fetchData();
  },
});
</script>
